"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.S7ProfiWhiteCircle = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var S7ProfiWhiteCircle = function S7ProfiWhiteCircle(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#S7ProfiWhiteCircle_svg__S7ProfiWhiteCircle_svg__S7ProfiWhiteCircle_svg__filter0_d_20466_109139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 31.004C52 42.054 43.052 51 32.006 51S12 42.053 12 31.004 20.959 11 32.006 11C43.052 11 52 19.955 52 31.004z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.811 21.363c1.472-.546 3.504-.719 6.638-.719h2.826l-1.383 3.459h-1.937c-2.08 0-3.415.006-4.136.245-.701.217-1.22.48-1.502.894-.261.335-.35.791-.35 1.188 0 .415.046.807.457 1.335.507.506 1.341 1.16 2.979 2.166 3.264 2.037 4.23 3.655 4.23 5.782 0 3.463-3.265 6.77-8.738 6.77-1.645 0-3.942-.242-4.91-.55l-.508-.15c.199-.659.849-2.474 1.135-3.242l.513.13c1.076.262 2.76.417 3.877.417 3.202 0 4.447-1.446 4.447-2.716 0-1.16-.634-1.797-3.812-3.723-2.977-1.84-4.006-3.44-4.006-5.65 0-2.653 1.708-4.672 4.18-5.636zm11.542-.719h9.733c.458 0 .545.323.369.675a20513.5 20513.5 0 00-6.641 16.623H34.8s4.743-12.086 5.53-13.886c-.182 0-.35.005-.574.012-.446.013-1.114.034-2.56.034H33.97l1.383-3.458z",
    fill: "#00A4BA"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "S7ProfiWhiteCircle_svg__S7ProfiWhiteCircle_svg__S7ProfiWhiteCircle_svg__filter0_d_20466_109139",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161741 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20466_109139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20466_109139",
    result: "shape"
  }))));
};

exports.S7ProfiWhiteCircle = S7ProfiWhiteCircle;
var _default = S7ProfiWhiteCircle;
exports.default = _default;